import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';

import { Box } from '@mui/material';

const tableCellSx = {
  padding: 1,
  fontSize: 16,
  verticalAlign:"top"
}

const tableCellIndicateSx = {
  ...tableCellSx, fontWeight: 700
}

// メールプレビューコンテナ
export function MailPreviewContainer({children}) {
  return (
    <Box border='1px grey solid'  display="inline-flex" width="100%" height="100%" sx={{overflowY: "auto"}}>
      <TableContainer component={null}>
        <Table>
          <TableBody>
            {children}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}

// メール宛先プレビュー
export function MailToPreview({mailToName}) {
  return (
    <TableRow>
      <TableCell width={85} sx={tableCellIndicateSx}>宛先</TableCell>
      <TableCell width={5} sx={tableCellSx}>:</TableCell>
      <TableCell sx={tableCellSx}>{mailToName} 様</TableCell>
    </TableRow>
  )
}

// メールタイトルプレビュー
export function MailSubjectPreview({mailSubject}) {
  return (
    <TableRow>
      <TableCell width={85} sx={tableCellIndicateSx}>タイトル</TableCell>
      <TableCell width={5} sx={tableCellSx}>:</TableCell>
      <TableCell sx={tableCellSx}>{mailSubject}</TableCell>
    </TableRow>
  )
}

// メール本文プレビュー
export function MailTextPreview({mailText}) {
  return (
    <TableRow>
      <TableCell width={85} sx={tableCellIndicateSx}>本文</TableCell>
      <TableCell width={5} sx={tableCellSx}>:</TableCell>
      <TableCell sx={{...tableCellSx, whiteSpace: "pre-wrap"}}>{mailText}</TableCell>
    </TableRow>
  )
}

// メールプレビュー
export default function MailPreview({mailToName, mailSubject, mailText}) {
  
  return (
    <MailPreviewContainer>
      <MailToPreview mailToName={mailToName} />
      <MailSubjectPreview mailSubject={mailSubject} />
      <MailTextPreview mailText={mailText} />
    </MailPreviewContainer>
  );
}

// メールプレビュー(宛名なし)
export function MailPreviewWithoutMailTo({mailSubject, mailText}) {

  return (
    <MailPreviewContainer>
      <MailSubjectPreview mailSubject={mailSubject} />
      <MailTextPreview mailText={mailText} />
    </MailPreviewContainer>
  );
}
